import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-arrow-narrow-left",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("line", {
  x1: "5",
  y1: "12",
  x2: "19",
  y2: "12"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("line", {
  x1: "5",
  y1: "12",
  x2: "9",
  y2: "16"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("line", {
  x1: "5",
  y1: "12",
  x2: "9",
  y2: "8"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_6))
}
export default render